const AUTH_LOGIN = 'auth_login_customer';
const AUTH_LOGIN_CODE = 'auth_login_customer_code';
const AUTH_GET_PROFILE = 'auth_get_profile';
const AUTH_LOGOUT = 'auth_logout';
const AUTH_CHECK = 'auth_check';
const AUTH_REQUEST_PASSWORD_RESET = 'auth_request_password_reset';
const AUTH_UPDATE_PASSWORD = 'auth_update_Password';
const AUTH_CHECK_RESET_CODE = 'auth_check_reset_code';
const AUTH_COMPLETE_REGISTRATION = 'auth_complete_registration';

export default {
    AUTH_LOGIN,
    AUTH_LOGIN_CODE,
    AUTH_GET_PROFILE,
    AUTH_LOGOUT,
    AUTH_CHECK,
    AUTH_REQUEST_PASSWORD_RESET,
    AUTH_UPDATE_PASSWORD,
    AUTH_CHECK_RESET_CODE,
    AUTH_COMPLETE_REGISTRATION,
};
